import { Component, Input, OnInit } from '@angular/core';
import { CmsUiProductSliderContent, Product, ProductQuery, ProductService, ProductSlider } from '@lobos/library';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-product-slider',
  templateUrl: './product-slider.component.html',
  styleUrls: ['./product-slider.component.scss'],
})
export class ProductSliderComponent implements OnInit {
  @Input() data!: CmsUiProductSliderContent;

  public products$: Observable<Product[]> | undefined;

  swiperOptions: SwiperOptions | undefined;

  constructor(private productService: ProductService, private productQuery: ProductQuery) {}

  ngOnInit(): void {
    this.productService
      .getProductsByIds(this.data.productsSlider.map((productsSlider: ProductSlider) => productsSlider.productNumber))
      .pipe(take(1))
      .subscribe();

    this.products$ = this.productQuery.selectByGroupIds(
      this.data.productsSlider.map((productsSlider: ProductSlider) => productsSlider.productNumber),
    );

    this.swiperOptions = {
      speed: 400,
      slidesPerView: 3,
      // slidesPerGroup: 1,
      spaceBetween: 20,
      breakpoints: {
        300: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
    };
  }
}
